<script>
export default {
  name: 'ConfirmModal',

  props: {
    closeModal: {
      type: Function,
      default: () => {},
    },
    onSubmit: {
      type: Function,
      required: true,
    },
    submitting: {
      type: Boolean,
      default: false
    },
    warningMessage:{
    type: String,
    required: false,
    default: null
  }
  },

  data() {
    return {
      showModal: true,
    }
  },
}
</script>

<template>
  <div>
    <b-modal
      centered
      v-model="showModal"
      hide-header
      hide-footer
      @hide="closeModal"
    >
    <div class="my-3 text-center">
      <div class="h5 text-primary font-weight-bold">Atención</div>
      <div v-if="warningMessage">{{ warningMessage }}</div>
      <slot></slot>
    </div>

      <b-row>
        <b-col class="p-3">
          <b-button-group class="w-100">
            <b-button variant="outline-primary" :disabled="submitting" @click="closeModal" class="rounded-lg mr-2">{{ $t('cancel') }}</b-button>
            <b-button variant="primary" :disabled="submitting" @click="onSubmit" class="rounded-lg">
              <b-spinner v-if="submitting" label="Spinning" small></b-spinner>
              <span v-if="submitting"> {{ $t('saving') }} </span>
              <span v-else>
                <i class="fe-save"></i>
                {{ $t('confirm') }}
              </span>
            </b-button>
          </b-button-group>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>